<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';

export default {
  page: {
    title: "Starter",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "My Profile",
      items: [
        {
          text: "My Profile",
          active: true,
        },
      ],
      ListUser:[],
      compnyDetail:[],
      OrgData:[],
        hasCompany:false,

        company_name:'',
        roc:'',
        address:'',
        organization:'',
        organization_id:'',
        bankname:'',
        accnumber:'',

        Myreferal:'',
      //form
        fullname:'',

        newpassword:'',
        newpasswordre:'',
        oldpassword:'',
      //end of form
    };
  },
  methods: {
    
    getMyProfile(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'user/my')
        .then(response => {
            if (response) {
                this.ListUser = response.data;

                this.fullname = response.data.name;
                this.email = response.data.email;
                this.phonenumber = response.data.phone_number;
                this.Myreferal = response.data.referral_email;

                if(response.data.company_id){
                    this.hasCompany=true;


                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.get(process.env.VUE_APP_API_BASEURL+'company/view')
                    .then(response => {
                        if (response) {
                            this.compnyDetail = response.data;

                            this.company_name=response.data.name;
                            this.roc=response.data.roc;
                            this.address=response.data.address;
                            this.organization_id=response.data.organization_id;
                            this.organization=response.data.organization;

                            this.bankname=response.data.bank_acc_name;
                            this.accnumber=response.data.bank_acc_no;
                            this.ssm_location=response.data.ssm_location;

                        } else {
                            // console.log('daddddd');
                            this.messageBag = ['No record.'];
                        }
                    })
                        .catch(error => {
                            this.messageBag = [error.error];
                    });



                }
            } else {
                // console.log('daddddd');
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

    organizationList(){
        axios.get(process.env.VUE_APP_API_BASEURL+'organization/list')
        .then(response => {
            if (response) {
                this.OrgData = response.data;
                // console.log(this.OrgData);
                this.loadingOrg=false;
            } else {
                this.messageBag = ['No record.'];
            }
        })
            .catch(error => {
                this.messageBag = [error.error];
        });
    },

    // MyReferral(){
    //     axios.get(process.env.VUE_APP_API_BASEURL+'reffral/myreferral')
    //     .then(response => {
    //         if (response) {
    //             this.Myreferal = response.data;
    //             // console.log(this.OrgData);
    //             this.loadingOrg=false;
    //         } else {
    //             this.messageBag = ['No record.'];
    //         }
    //     })
    //         .catch(error => {
    //             this.messageBag = [error.error];
    //     });
    // },


    

    EditProfile(e){
            
        e.preventDefault()

        const posting_ = { 
            typeUser: this.typeUser,
            name: this.fullname,
            email: this.email,
            password: this.password,
            phone_number: this.phonenumber,
            referal: this.Myreferal,
        }; 
       
        // console.log('-----');
        // console.log(this.URLRider);
        // console.log('-----');
        // console.log(posting_);

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'profile/edit', posting_)
        .then(response => {
            if (response) {
                alert(response.data.msj);
                // console.log(response);
                // this.getListUser();
            }else{
                console.log('tak ok');
            }
        });

    },

    EditCompany(e){
        e.preventDefault();

        // this.company_name=response.data.name;
        // this.roc=response.data.roc;
        // this.address=response.data.address;
        // this.organization_id=response.data.organization_id;
        // this.organization=response.data.organization;

        const formData = new FormData();
            formData.append('uploaded_file', this.Images);
            formData.append('name', this.company_name);
            formData.append('roc', this.roc);
            formData.append('bankname', this.bankname);
            formData.append('accnumber', this.accnumber);
            formData.append('address', this.address);

        // const posting_con = { 
        //     name: this.company_name,
        //     roc: this.roc,
        //     address: this.address,
        //     uploaded_file: this.Images,

        //     bankname: this.bankname,
        //     accnumber: this.accnumber,
        //     ssm_location: this.ssm_location,
        // }; 

        


        const headers = { 'Content-Type': 'multipart/form-data' };
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'company/edit', formData, { headers })
        .then(response => {
            if (response) {
                alert(response.data.msj);
                // console.log(response);
                // this.getListUser();
            }else{
                console.log('tak ok');
            }
        });
    },

    EditPassword(e){
        e.preventDefault();

        if(this.newpassword == this.newpasswordre){

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'profile/passwordcheck', { passwordold: this.oldpassword })
            .then(response => {
            if (response) {
                if(response.data.status == 'success'){
                    
                    const posting_password = { 
                        password: this.newpassword,
                        newpasswordre: this.newpasswordre,
                    }; 

                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_API_BASEURL+'reset-password_new', posting_password )
                    .then(response => {
                        if (response) {
                            alert(response.data.message);
                        }
                    });

                }else{
                    alert(response.data.message);
                }
                // console.log(response.data);
            }else{
                console.log('tak ok');
            }
        });


        }else{
            alert('Re password not same with new password')
        }
    },

    uploadFile() {
        this.isDisabled=false;
        // console.log('xxxx');
        this.Images = this.$refs.file.files[0];
    },

},
  components: {
    Layout,
    PageHeader,
  },

  mounted() {
    this.organizationList();
    this.getMyProfile();
    // this.MyReferral();
},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        
        <div class="row">
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">

                        <ul class="nav nav-tabs mb-3" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" href="#Summary" role="tab" aria-selected="false">
                                    Edit Profile
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#detailOrder" role="tab"
                                    aria-selected="false">
                                    Edit Password
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content  text-muted">
                            <div class="tab-pane active" id="Summary" role="tabpanel">   
                                <form @submit="EditProfile" id="EditProfile">
                                    <div class="row g-3">
                                        <div class="col-xxl-12">
                                            <div>
                                                <label for="firstName" class="form-label">Full Name</label>
                                                <input type="text" v-model='fullname' class="form-control" id="firstName" placeholder="Enter Full Name" required/>
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-12">
                                            <label for="emailInput" class="form-label">Email</label>
                                            <input type="email" class="form-control" id="emailInput" v-model='email' placeholder="Enter email" required/>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-12">
                                            <label for="emailInput" class="form-label">Phone Number</label>
                                            <input type="text" class="form-control" id="phoneInput" v-model='phonenumber' placeholder="Enter Phone Number" required/>
                                        </div>
                                        <!--end col-->
                                        <!--end col-->
                                        <div class="col-xxl-12">
                                            <label for="emailInput" class="form-label">Referral Email</label>
                                            <input type="email" class="form-control" id="Myreferal" v-model='Myreferal' placeholder="Enter Referral Email" required/>
                                        </div>
                                        <!--end col-->
                                        <div class="col-lg-12">
                                            <div class="hstack gap-2 justify-content-end">
                                                <button type="submit" class="btn btn-primary">Update Profile</button>
                                            </div>
                                        </div>
                                        <!--end col-->
                                    </div>
                                    <!--end row-->
                                </form>
                            </div>
                            <div class="tab-pane" id="detailOrder" role="tabpanel">   
                                <form @submit="EditPassword" id="EditPassword">
                                    <div class="row g-3">
                                        <div class="col-xxl-12">
                                            <div>
                                                <label for="firstName" class="form-label">Old Password</label>
                                                <input type="password" v-model='oldpassword' class="form-control" id="firstName" placeholder="********" required/>
                                            </div>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-12">
                                            <label for="emailInput" class="form-label">New Password</label>
                                            <input type="password" class="form-control" id="emailInput" v-model='newpassword' placeholder="********" required/>
                                        </div>
                                        <!--end col-->
                                        <div class="col-xxl-12">
                                            <label for="emailInput" class="form-label">Confirm Password</label>
                                            <input type="password" class="form-control" id="phoneInput" v-model='newpasswordre' placeholder="********" required/>
                                        </div>
                                        <!--end col-->
                                        <div class="col-lg-12">
                                            <div class="hstack gap-2 justify-content-end">
                                                <button type="submit" class="btn btn-primary">Update Password</button>
                                            </div>
                                        </div>
                                        <!--end col-->
                                    </div>
                                    <!--end row-->
                                </form>
                            </div>
                        </div>


                        
                    </div>
                </div>
            </div>
            <div class="col-lg-6" v-if="hasCompany">
                <div class="card">
                    <div class="card-body">
                        <form @submit="EditCompany" id="EditCompany">
                            <div class="row g-3">
                                <div class="col-xxl-12">
                                    <div>
                                        <label for="company_name" class="form-label">Company Name</label>
                                        <input type="text" v-model='company_name' class="form-control" id="company_name" required/>
                                    </div>
                                </div>
                                <!--end col-->
                                <div class="col-xxl-12">
                                    <label for="roc" class="form-label">Company Registration No.</label>
                                    <input type="text" class="form-control" id="roc" v-model='roc' required/>
                                </div>
                                <!--end col-->
                                <div class="col-xxl-12">
                                    <label for="emailInput" class="form-label">Address</label>
                                    <textarea rows="5" class="form-control" id="address" v-model='address' required/>
                                </div>

                                <div class="col-xxl-12">
                                    <label for="roc" class="form-label">Bank Name</label>
                                    <input type="text" class="form-control" id="roc" v-model='bankname' required/>
                                </div>

                                <div class="col-xxl-12">
                                    <label for="roc" class="form-label">Bank Account Number</label>
                                    <input type="text" class="form-control" id="roc" v-model='accnumber' required/>
                                </div>

                                <div class="col-xxl-12">
                                    <label for="roc" class="form-label">Upload Company Registration Certificate </label>
                                    <input type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload">
                                    <span v-if="ssm_location != ''">
                                        <!-- {{ ssm_location }} -->
                                    </span>
                                </div>

                                <!--end col-->
                                <div class="col-lg-12">
                                    <div class="hstack gap-2 justify-content-end">
                                        <button type="submit" class="btn btn-primary">Update Company</button>
                                    </div>
                                </div>

                                <!-- <div class="col-lg-12">
                                    <div class="input-group ">
                                        <input type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload">
                                        <button class="btn btn-outline-success" type="button" id="inputGroupFileAddon04" @click="submitFile" :disabled='isDisabled'>Upload</button>
                                    </div>
                                </div> -->

                                <!--end col-->
                            </div>
                            <!--end row-->
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>